(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2344],{

/***/ 62344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ tagsRow_TagsRow; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./containers/tagsRow/TagsRow.module.scss
var TagsRow_module = __webpack_require__(10387);
var TagsRow_module_default = /*#__PURE__*/__webpack_require__.n(TagsRow_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/tagsRow/TagsRow.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/anchor-is-valid */






var TagsRow = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var tags = _ref.tags,
      parentId = _ref.parentId;

  var _useState = (0,react.useState)({
    fromStart: false,
    reachEnd: true
  }),
      scrollState = _useState[0],
      setScrollState = _useState[1];

  var fromStart = scrollState.fromStart,
      reachEnd = scrollState.reachEnd;
  var tagsRef = (0,react.useRef)();
  var checkEnd = (0,react.useCallback)(function () {
    if (tagsRef.current) {
      var target = tagsRef.current;
      var scrollWidth = target.scrollWidth;
      var scrollLeft = target.scrollLeft;
      var targetWidth = target.offsetWidth;
      var nextFromStart = scrollLeft > 2;
      var nextReachEnd = scrollWidth - scrollLeft - targetWidth < 2;

      if (reachEnd !== nextReachEnd) {
        setScrollState(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            reachEnd: nextReachEnd
          });
        });
      }

      if (fromStart !== nextFromStart) {
        setScrollState(function (prev) {
          return _objectSpread(_objectSpread({}, prev), {}, {
            fromStart: nextFromStart
          });
        });
      }
    }
  }, [fromStart, reachEnd]);
  (0,react.useEffect)(function () {
    checkEnd();
  }, [checkEnd]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (TagsRow_module_default()).row,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: (0,clsx_m/* default */.Z)((TagsRow_module_default()).list, fromStart && (TagsRow_module_default()).gradientLeft, !reachEnd && (TagsRow_module_default()).gradientRight),
      ref: tagsRef,
      children: tags.map(function (tag) {
        var name = tag.name,
            slug = tag.slug;

        var _getLinkProps = (0,getLinkProps/* default */.Z)({
          type: 'catalog',
          value: slug
        }),
            _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
            href = _getLinkProps2[0],
            as = _getLinkProps2[1];

        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          className: (TagsRow_module_default()).item,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: href,
            as: as,
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (TagsRow_module_default()).link,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: name
              })
            })
          })
        }, slug);
      })
    })
  });
});
/* harmony default export */ var tagsRow_TagsRow = (TagsRow);
;// CONCATENATED MODULE: ./containers/tagsRow/index.js


/***/ }),

/***/ 10387:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"TagsRow_row__WgElh","list":"TagsRow_list__uuOAI","gradientLeft":"TagsRow_gradientLeft__LOsrk","gradientRight":"TagsRow_gradientRight__7vkef","item":"TagsRow_item__b2HlR","link":"TagsRow_link__GjoDH","load":"TagsRow_load__UwKNq"};

/***/ })

}]);